module.exports = __webpack_public_path__ + "static/mobile@2x-3a1a29b23dcb1cd2863123dab734c657.jpg";